import PublicAppointmentPage from "@/components/booking/public/PublicAppointmentPage";

export default function PublicAppointmentPaymentPage() {
  return <PublicAppointmentPage variant="payment" />;
}
